import { useSetAtom } from 'jotai';
import { IconSquareCheck } from '@optiaxiom/icons';
import { Button, Tooltip } from '@optiaxiom/react';

import { stickyboardDrawerVisibleAtom } from '@frontend/atoms/stickyboardAtoms';

/**
 * Top-toolbar toggle for the Tracker drawer, sitting beside the "Ask Opal"
 * button. A checkbox icon (matching the design) that opens/closes the Tracker
 * panel — the drawer is Tracker's only surface (no full page).
 */
export function TrackerToggleButton() {
  const setVisible = useSetAtom(stickyboardDrawerVisibleAtom);

  return (
    <Tooltip content="Open Tracker" delayDuration={0}>
      <Button
        appearance="subtle"
        aria-label="Open Tracker"
        icon={<IconSquareCheck />}
        // Matches the notification bell beside it, which renders lg — the
        // 2026-07-24 review flagged the two as visibly mismatched.
        size="lg"
        onClick={() => setVisible(v => !v)}
        data-testid="tracker-toggle"
        z="10"
      />
    </Tooltip>
  );
}
